import { render } from "./DocumentFileListsCard.vue?vue&type=template&id=3a46e5cc&scoped=true"
import script from "./DocumentFileListsCard.vue?vue&type=script&lang=js"
export * from "./DocumentFileListsCard.vue?vue&type=script&lang=js"

import "./DocumentFileListsCard.vue?vue&type=style&index=0&id=3a46e5cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a46e5cc"]])

export default __exports__